// extracted by mini-css-extract-plugin
module.exports = {"searchHorizontalRecosContainer":"ER","reco":"FR","products":"GR"};